import { useState, useEffect, useCallback, useRef } from "react";
import api from "../api";
import { useTheme } from "../components/Theme";

const ORANGE = "#FF6B2B";

const CORES_DISPONIVEIS = [
  "#6366f1","#f59e0b","#10b981","#3b82f6","#e879f9","#ef4444",
  "#8b5cf6","#ec4899","#14b8a6","#f97316","#84cc16","#06b6d4",
];

const ETAPAS_NEG = [
  { id: "prospeccao", label: "Prospecção",       color: "#6366f1" },
  { id: "contato",    label: "Contato",           color: "#f59e0b" },
  { id: "reuniao",    label: "Reunião",           color: "#3b82f6" },
  { id: "proposta",   label: "Proposta enviada",  color: "#8b5cf6" },
  { id: "aprovacao",  label: "Aguard. aprovação", color: "#e879f9" },
  { id: "fechado",    label: "Fechado",           color: "#10b981" },
  { id: "perdido",    label: "Perdido",           color: "#ef4444" },
];

const ORIGENS = ["Instagram","Google","Indicação","WhatsApp","Facebook","Site","Outro"];

function fmt(v) { return v||v===0 ? `R$${Number(v).toLocaleString("pt-BR")}` : ""; }
function fmtData(d) { return d ? new Date(d).toLocaleDateString("pt-BR") : ""; }

// ── MODAL GRUPO ──────────────────────────────────────────
function ModalGrupo({ grupo, onClose, onSave, onDelete }) {
  const { theme } = useTheme();
  const isNew = !grupo?._id;
  const [label, setLabel] = useState(grupo?.label||"");
  const [color, setColor] = useState(grupo?.color||CORES_DISPONIVEIS[0]);
  const [load, setLoad]   = useState(false);

  const salvar = async () => {
    if (!label.trim()) return;
    setLoad(true);
    try { await onSave({...grupo, label, color}); onClose(); }
    catch(e) { alert(e.response?.data?.erro||"Erro"); }
    finally { setLoad(false); }
  };

  const inp = { width:"100%", boxSizing:"border-box", background:theme.bgInput, border:`1.5px solid ${theme.border}`, borderRadius:10, padding:"10px 14px", color:theme.text, fontSize:14, outline:"none", fontFamily:"'Inter',sans-serif" };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,.7)", zIndex:2000, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={onClose}>
      <div style={{ background:theme.bgCard, border:`1px solid ${theme.border}`, borderRadius:16, padding:28, width:"100%", maxWidth:380, boxShadow:"0 24px 80px rgba(0,0,0,.6)" }} onClick={e=>e.stopPropagation()}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
          <h3 style={{ margin:0, fontSize:17, fontWeight:700, color:theme.text }}>{isNew?"Novo grupo":"Editar grupo"}</h3>
          <button onClick={onClose} style={{ background:theme.bgInput, border:"none", borderRadius:8, width:30, height:30, color:theme.textMuted, fontSize:17, cursor:"pointer" }}>×</button>
        </div>
        <div style={{ marginBottom:16 }}>
          <label style={{ fontSize:11, color:theme.textMuted, display:"block", marginBottom:6, fontWeight:600, letterSpacing:".04em", textTransform:"uppercase" }}>Nome do grupo</label>
          <input value={label} onChange={e=>setLabel(e.target.value)} style={inp} placeholder="Ex: Orçamentos, Aguardando Aprovação..."
            onFocus={e=>e.target.style.borderColor=ORANGE} onBlur={e=>e.target.style.borderColor=theme.border}
            onKeyDown={e=>e.key==="Enter"&&salvar()} autoFocus/>
        </div>
        <div style={{ marginBottom:22 }}>
          <label style={{ fontSize:11, color:theme.textMuted, display:"block", marginBottom:8, fontWeight:600, letterSpacing:".04em", textTransform:"uppercase" }}>Cor</label>
          <div style={{ display:"flex", flexWrap:"wrap", gap:8 }}>
            {CORES_DISPONIVEIS.map(c=>(
              <div key={c} onClick={()=>setColor(c)} style={{ width:28, height:28, borderRadius:8, background:c, cursor:"pointer", border:color===c?`3px solid ${theme.text}`:"3px solid transparent", boxShadow:color===c?`0 0 0 2px ${c}66`:"none", transition:"all .15s" }}/>
            ))}
          </div>
        </div>
        <div style={{ background:color+"15", border:`2px solid ${color}`, borderRadius:10, padding:"8px 14px", marginBottom:20, display:"flex", alignItems:"center", gap:8 }}>
          <span style={{ fontWeight:700, color, fontSize:14 }}>{label||"Pré-visualização"}</span>
          <span style={{ background:color+"33", color, borderRadius:99, fontSize:11, fontWeight:700, padding:"1px 8px", marginLeft:"auto" }}>0</span>
        </div>
        <div style={{ display:"flex", gap:10 }}>
          <button onClick={salvar} disabled={load||!label.trim()} style={{ flex:1, background:`linear-gradient(135deg,${color},${color}CC)`, border:"none", borderRadius:10, padding:"11px 0", color:"#fff", fontWeight:700, fontSize:14, cursor:"pointer", opacity:!label.trim()?.5:1 }}>
            {load?"Salvando...":"Salvar grupo"}
          </button>
          {!isNew && <button onClick={()=>{ onDelete(grupo._id); onClose(); }} style={{ background:"#ef444418", border:"1px solid #ef444433", borderRadius:10, padding:"11px 14px", color:"#ef4444", fontWeight:700, fontSize:13, cursor:"pointer" }}>Excluir</button>}
        </div>
      </div>
    </div>
  );
}

// ── MENU MOVER ENTRE GRUPOS ──────────────────────────────
function MenuMover({ lead, grupos, onMover, onClose }) {
  const { theme } = useTheme();
  const ref = useRef();

  useEffect(() => {
    const h = e => { if(ref.current&&!ref.current.contains(e.target)) onClose(); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const grupoAtualId = String(lead.grupoNegociacaoId||"");

  return (
    <div ref={ref} style={{ position:"fixed", zIndex:3000, background:"#2C2C2F", border:"1px solid #3D3D42", borderRadius:14, padding:8, minWidth:220, boxShadow:"0 16px 48px rgba(0,0,0,.6)" }}>
      <div style={{ fontSize:11, color:"#8E8E93", fontWeight:600, letterSpacing:".05em", textTransform:"uppercase", padding:"6px 10px 8px" }}>Mover para grupo</div>
      {/* Sem grupo */}
      <div onClick={()=>onMover(null,null)} style={{ display:"flex", alignItems:"center", gap:10, padding:"8px 10px", borderRadius:8, cursor:"pointer", background:!grupoAtualId?"#8E8E9320":"transparent" }}
        onMouseEnter={e=>e.currentTarget.style.background="#8E8E9318"}
        onMouseLeave={e=>e.currentTarget.style.background=!grupoAtualId?"#8E8E9320":"transparent"}>
        <div style={{ width:10, height:10, borderRadius:3, background:"#8E8E93" }}/>
        <span style={{ fontSize:13, color:"#F2F2F7" }}>Sem grupo</span>
        {!grupoAtualId && <span style={{ marginLeft:"auto", fontSize:11, color:"#8E8E93" }}>atual</span>}
      </div>
      {grupos.map(g=>(
        <div key={g._id} onClick={()=>onMover(g._id,g.label)} style={{ display:"flex", alignItems:"center", gap:10, padding:"8px 10px", borderRadius:8, cursor:"pointer", background:grupoAtualId===String(g._id)?g.color+"20":"transparent" }}
          onMouseEnter={e=>e.currentTarget.style.background=g.color+"18"}
          onMouseLeave={e=>e.currentTarget.style.background=grupoAtualId===String(g._id)?g.color+"20":"transparent"}>
          <div style={{ width:10, height:10, borderRadius:3, background:g.color }}/>
          <span style={{ fontSize:13, color:"#F2F2F7", fontWeight:grupoAtualId===String(g._id)?600:400 }}>{g.label}</span>
          {grupoAtualId===String(g._id) && <span style={{ marginLeft:"auto", fontSize:11, color:g.color }}>atual</span>}
        </div>
      ))}
    </div>
  );
}

// ── BADGE ETAPA ──────────────────────────────────────────
function EtapaBadge({ stage, etapaNegociacao, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const etapa = ETAPAS_NEG.find(e=>e.id===stage)||ETAPAS_NEG[0];
  useEffect(() => {
    const h = e => { if(ref.current&&!ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  return (
    <div ref={ref} style={{ position:"relative", display:"inline-block" }}>
      <div onClick={()=>setOpen(o=>!o)} style={{ background:etapa.color, borderRadius:6, padding:"4px 14px", fontSize:12, fontWeight:600, color:"#fff", cursor:"pointer", whiteSpace:"nowrap" }}>
        {etapaNegociacao||etapa.label}
      </div>
      {open && (
        <div style={{ position:"absolute", top:"110%", left:0, zIndex:500, background:"#2C2C2F", border:"1px solid #3D3D42", borderRadius:12, padding:6, minWidth:200, boxShadow:"0 12px 40px rgba(0,0,0,.5)" }}>
          {ETAPAS_NEG.map(e=>(
            <div key={e.id} onClick={()=>{ onChange(e.id,e.label); setOpen(false); }}
              style={{ display:"flex", alignItems:"center", gap:10, padding:"7px 10px", borderRadius:8, cursor:"pointer" }}
              onMouseEnter={ev=>ev.currentTarget.style.background=e.color+"18"}
              onMouseLeave={ev=>ev.currentTarget.style.background="transparent"}>
              <div style={{ width:10, height:10, borderRadius:3, background:e.color }}/>
              <span style={{ fontSize:13, color:"#F2F2F7", fontWeight:stage===e.id?600:400 }}>{e.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── INLINE EDIT ──────────────────────────────────────────
function InlineEdit({ value, onChange, placeholder="—", style:s={} }) {
  const { theme } = useTheme();
  const [editing, setEditing] = useState(false);
  const [val, setVal]         = useState(value||"");
  const ref = useRef();
  useEffect(()=>{ setVal(value||""); },[value]);
  useEffect(()=>{ if(editing&&ref.current) ref.current.focus(); },[editing]);
  const commit=()=>{ setEditing(false); if(String(val)!==String(value||"")) onChange(val); };
  if(editing) return (
    <input ref={ref} value={val} onChange={e=>setVal(e.target.value)}
      onBlur={commit} onKeyDown={e=>{ if(e.key==="Enter")commit(); if(e.key==="Escape"){setVal(value||"");setEditing(false);} }}
      style={{ background:"transparent", border:"none", borderBottom:`1.5px solid ${ORANGE}`, outline:"none", color:theme.text, fontSize:13, width:"100%", padding:"2px 0", fontFamily:"'Inter',sans-serif", ...s }}/>
  );
  return (
    <div onClick={()=>setEditing(true)} style={{ cursor:"text", color:value?theme.text:theme.textMuted, fontSize:13, padding:"2px 4px", borderRadius:6, minWidth:30, ...s }}
      onMouseEnter={e=>e.currentTarget.style.background="rgba(255,107,43,.08)"}
      onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
      {value||<span style={{ color:theme.textMuted, fontSize:12 }}>{placeholder}</span>}
    </div>
  );
}

// ── MODAL OPORTUNIDADE ───────────────────────────────────
function ModalOportunidade({ lead, grupos, onClose, onSave, onDelete }) {
  const { theme } = useTheme();
  const isNew = !lead?._id;
  const [form, setForm] = useState({
    nome: lead?.nome||"", empresa: lead?.empresa||"", telefone: lead?.telefone||"", email: lead?.email||"",
    origem: lead?.origem||"Instagram", valor: lead?.valor||"", probabilidade: lead?.probabilidade||"",
    dataFechamento: lead?.dataFechamento?new Date(lead.dataFechamento).toISOString().slice(0,10):"",
    obs: lead?.obs||"", stage: lead?.stage||"prospeccao",
    etapaNegociacao: lead?.etapaNegociacao||"",
    grupoNegociacaoId: lead?.grupoNegociacaoId||"",
    grupoNegociacaoLabel: lead?.grupoNegociacaoLabel||"",
  });
  const [nota, setNota] = useState("");
  const [load, setLoad] = useState(false);
  const set=(k,v)=>setForm(f=>({...f,[k]:v}));
  const inp={ width:"100%", boxSizing:"border-box", background:theme.bgInput, border:`1.5px solid ${theme.border}`, borderRadius:10, padding:"9px 12px", color:theme.text, fontSize:13, outline:"none", colorScheme:theme.name, fontFamily:"'Inter',sans-serif", transition:"border-color .15s" };

  const salvar=async()=>{
    if(!form.nome.trim()) return alert("Nome obrigatório");
    setLoad(true);
    try{ await onSave({...lead,...form}); }catch(e){ alert(e.response?.data?.erro||"Erro"); }finally{ setLoad(false); }
  };
  const addNota=async()=>{
    if(!nota.trim()||!lead?._id) return;
    await api.post(`/leads/${lead._id}/atividades`,{tipo:"nota",descricao:nota});
    setNota(""); onClose();
  };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,.75)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={onClose}>
      <div style={{ background:theme.bgCard, border:`1px solid ${theme.border}`, borderRadius:20, padding:30, width:"100%", maxWidth:540, maxHeight:"90vh", overflowY:"auto", boxShadow:"0 24px 80px rgba(0,0,0,.6)" }} onClick={e=>e.stopPropagation()}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:20 }}>
          <div>
            <div style={{ fontSize:11, color:ORANGE, fontWeight:700, letterSpacing:1, textTransform:"uppercase", marginBottom:4 }}>OPORTUNIDADE</div>
            <h2 style={{ margin:0, fontSize:20, fontWeight:700, color:theme.text }}>{form.nome||"Nova oportunidade"}</h2>
          </div>
          <button onClick={onClose} style={{ background:theme.bgInput, border:"none", borderRadius:8, width:32, height:32, color:theme.textMuted, fontSize:18, cursor:"pointer" }}>×</button>
        </div>

        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:14 }}>
          <div>
            <label style={{ fontSize:11, color:theme.textMuted, display:"block", marginBottom:6, fontWeight:600, letterSpacing:".04em", textTransform:"uppercase" }}>Grupo</label>
            <select value={form.grupoNegociacaoId||""} onChange={e=>{ const g=grupos.find(x=>x._id===e.target.value); set("grupoNegociacaoId",e.target.value); set("grupoNegociacaoLabel",g?.label||""); }} style={{ ...inp, appearance:"auto" }}
              onFocus={e=>e.target.style.borderColor=ORANGE} onBlur={e=>e.target.style.borderColor=theme.border}>
              <option value="">Sem grupo</option>
              {grupos.map(g=><option key={g._id} value={g._id}>{g.label}</option>)}
            </select>
          </div>
          <div>
            <label style={{ fontSize:11, color:theme.textMuted, display:"block", marginBottom:6, fontWeight:600, letterSpacing:".04em", textTransform:"uppercase" }}>Etapa</label>
            <select value={form.stage} onChange={e=>{ const et=ETAPAS_NEG.find(x=>x.id===e.target.value); set("stage",e.target.value); set("etapaNegociacao",et?.label||""); }} style={{ ...inp, appearance:"auto" }}
              onFocus={e=>e.target.style.borderColor=ORANGE} onBlur={e=>e.target.style.borderColor=theme.border}>
              {ETAPAS_NEG.map(e=><option key={e.id} value={e.id}>{e.label}</option>)}
            </select>
          </div>
        </div>

        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 }}>
          {[["Nome *","nome"],["Empresa","empresa"],["Telefone","telefone"],["Email","email"]].map(([label,key])=>(
            <div key={key}>
              <label style={{ fontSize:11, color:theme.textMuted, display:"block", marginBottom:5, fontWeight:600, letterSpacing:".04em", textTransform:"uppercase" }}>{label}</label>
              <input value={form[key]||""} onChange={e=>set(key,e.target.value)} style={inp}
                onFocus={e=>e.target.style.borderColor=ORANGE} onBlur={e=>e.target.style.borderColor=theme.border}/>
            </div>
          ))}
        </div>

        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12, marginBottom:12 }}>
          {[["Valor (R$)","valor","number"],["Probabilidade %","probabilidade","number"],["Fechamento","dataFechamento","date"]].map(([label,key,type])=>(
            <div key={key}>
              <label style={{ fontSize:11, color:theme.textMuted, display:"block", marginBottom:5, fontWeight:600, letterSpacing:".04em", textTransform:"uppercase" }}>{label}</label>
              <input type={type} value={form[key]||""} onChange={e=>set(key,e.target.value)} style={inp}
                onFocus={e=>e.target.style.borderColor=ORANGE} onBlur={e=>e.target.style.borderColor=theme.border}/>
            </div>
          ))}
        </div>

        <div style={{ marginBottom:16 }}>
          <label style={{ fontSize:11, color:theme.textMuted, display:"block", marginBottom:5, fontWeight:600, letterSpacing:".04em", textTransform:"uppercase" }}>Observações</label>
          <textarea value={form.obs||""} onChange={e=>set("obs",e.target.value)} rows={2} style={{ ...inp, resize:"vertical" }}
            onFocus={e=>e.target.style.borderColor=ORANGE} onBlur={e=>e.target.style.borderColor=theme.border}/>
        </div>

        {!isNew && lead?.atividades?.length>0 && (
          <div style={{ marginBottom:14 }}>
            <label style={{ fontSize:11, color:theme.textMuted, display:"block", marginBottom:8, fontWeight:600, letterSpacing:".04em", textTransform:"uppercase" }}>Histórico</label>
            {[...lead.atividades].reverse().slice(0,3).map((a,i)=>(
              <div key={i} style={{ background:theme.bgInput, borderRadius:8, padding:"8px 12px", marginBottom:6 }}>
                <div style={{ display:"flex", justifyContent:"space-between", marginBottom:3 }}>
                  <span style={{ color:ORANGE, fontWeight:600, fontSize:12 }}>{a.nomeUsuario}</span>
                  <span style={{ fontSize:11, color:theme.textMuted }}>{new Date(a.createdAt).toLocaleDateString("pt-BR")}</span>
                </div>
                <div style={{ fontSize:13, color:theme.textSub }}>{a.descricao}</div>
              </div>
            ))}
          </div>
        )}

        {!isNew && (
          <div style={{ display:"flex", gap:8, marginBottom:16 }}>
            <input value={nota} onChange={e=>setNota(e.target.value)} placeholder="Adicionar nota..." style={{ ...inp, flex:1 }}
              onFocus={e=>e.target.style.borderColor=ORANGE} onBlur={e=>e.target.style.borderColor=theme.border}/>
            <button onClick={addNota} style={{ background:ORANGE, border:"none", borderRadius:10, padding:"9px 14px", color:"#fff", cursor:"pointer", fontSize:13, fontWeight:700 }}>+</button>
          </div>
        )}

        <div style={{ display:"flex", gap:10 }}>
          <button onClick={salvar} disabled={load} style={{ flex:1, background:`linear-gradient(135deg,${ORANGE},#FF9A5C)`, border:"none", borderRadius:12, padding:"13px 0", color:"#fff", fontWeight:700, fontSize:15, cursor:"pointer", opacity:load?.7:1, boxShadow:`0 4px 14px ${ORANGE}44` }}>
            {load?"Salvando...":"Salvar"}
          </button>
          {!isNew && <button onClick={()=>onDelete(lead._id)} style={{ background:"#ef444418", border:"1px solid #ef444433", borderRadius:12, padding:"13px 18px", color:"#ef4444", fontWeight:600, fontSize:14, cursor:"pointer" }}>Excluir</button>}
        </div>
      </div>
    </div>
  );
}

// ── LINHA NOVA ───────────────────────────────────────────
function LinhaNovaRow({ grupoId, grupoLabel, onAdd, onCancel }) {
  const { theme } = useTheme();
  const [nome, setNome] = useState("");
  const ref = useRef();
  useEffect(()=>{ ref.current?.focus(); },[]);
  return (
    <tr style={{ background:theme.bgInput }}>
      <td style={{ padding:"7px 10px" }}><input type="checkbox" disabled/></td>
      <td colSpan={2} style={{ padding:"7px 14px" }}>
        <input ref={ref} value={nome} onChange={e=>setNome(e.target.value)}
          onKeyDown={e=>{ if(e.key==="Enter"&&nome.trim()) onAdd(nome.trim(),grupoId,grupoLabel); if(e.key==="Escape") onCancel(); }}
          placeholder="Nome da oportunidade... (Enter para adicionar)"
          style={{ background:"transparent", border:"none", borderBottom:`1.5px solid ${ORANGE}`, outline:"none", color:theme.text, fontSize:13, width:"100%", padding:"2px 0", fontFamily:"'Inter',sans-serif" }}/>
      </td>
      <td colSpan={6} style={{ padding:"7px 12px" }}>
        <span style={{ fontSize:11, color:theme.textMuted }}>↵ Enter · Esc para cancelar</span>
      </td>
    </tr>
  );
}

// ── COMPONENTE PRINCIPAL ─────────────────────────────────
export default function Negociacoes({ currentUser }) {
  const { theme } = useTheme();
  const [leads,    setLeads]   = useState([]);
  const [grupos,   setGrupos]  = useState([]);
  const [loading,  setLoading] = useState(true);
  const [search,   setSearch]  = useState("");
  const [modal,    setModal]   = useState(null);
  const [modalGrupo, setModalGrupo] = useState(null);
  const [novaLinhaGrupo, setNovaLinhaGrupo] = useState(null);
  const [colapsados, setColapsados] = useState({});
  const [selected, setSelected] = useState([]);

  // Drag entre grupos
  const [dragLeadId, setDragLeadId]       = useState(null);
  const [dragOverGrupo, setDragOverGrupo] = useState(null);

  // Menu de mover (⋮)
  const [menuMover, setMenuMover] = useState(null); // { lead, x, y }

  const carregar = useCallback(async () => {
    try {
      const [leadsRes, gruposRes] = await Promise.all([
        api.get("/leads?limit=1000&tipo=negociacao"),
        api.get("/grupos"),
      ]);
      setLeads(leadsRes.data.leads);
      setGrupos(gruposRes.data.grupos);
    } catch {} finally { setLoading(false); }
  }, []);

  useEffect(()=>{ carregar(); },[carregar]);

  // Mover lead para grupo (drag ou menu)
  const moverParaGrupo = async (leadId, grupoId, grupoLabel) => {
    try {
      await api.put(`/leads/${leadId}`, {
        grupoNegociacaoId: grupoId||null,
        grupoNegociacaoLabel: grupoLabel||null,
      });
      setLeads(prev=>prev.map(l=>l._id===leadId?{...l,grupoNegociacaoId:grupoId||null,grupoNegociacaoLabel:grupoLabel||null}:l));
    } catch {}
  };

  // Mover selecionados
  const moverSelecionadosParaGrupo = async (grupoId, grupoLabel) => {
    await Promise.all(selected.map(id=>moverParaGrupo(id,grupoId,grupoLabel)));
    setSelected([]);
  };

  const salvarGrupo = async (form) => {
    if(form._id){ const{data}=await api.put(`/grupos/${form._id}`,form); setGrupos(prev=>prev.map(g=>g._id===data._id?data:g)); }
    else{ const{data}=await api.post("/grupos",form); setGrupos(prev=>[...prev,data]); }
  };

  const excluirGrupo = async (id) => {
    await api.delete(`/grupos/${id}`);
    setGrupos(prev=>prev.filter(g=>g._id!==id));
    setLeads(prev=>prev.map(l=>String(l.grupoNegociacaoId)===String(id)?{...l,grupoNegociacaoId:null,grupoNegociacaoLabel:null}:l));
  };

  const salvarLead = async (form) => {
    if(form._id){ const{data}=await api.put(`/leads/${form._id}`,form); setLeads(prev=>prev.map(l=>l._id===data._id?data:l)); }
    else{ const{data}=await api.post("/leads",{...form,stage:form.stage||"prospeccao",origem:form.origem||"Instagram"}); setLeads(prev=>[data,...prev]); }
    setModal(null);
  };

  const excluirLead = async (id) => {
    await api.delete(`/leads/${id}`);
    setLeads(prev=>prev.filter(l=>l._id!==id));
    setModal(null);
  };

  const atualizarCampo = async (id, campo, valor) => {
    try{ const{data}=await api.put(`/leads/${id}`,{[campo]:valor}); setLeads(prev=>prev.map(l=>l._id===id?{...l,...data}:l)); }catch{}
  };

  const atualizarEtapa = async (id, stage, etapaNegociacao) => {
    try{ await api.put(`/leads/${id}`,{stage,etapaNegociacao}); setLeads(prev=>prev.map(l=>l._id===id?{...l,stage,etapaNegociacao}:l)); }catch{}
  };

  const adicionarLead = async (nome, grupoId, grupoLabel) => {
    try{
      const{data}=await api.post("/leads",{ nome, tipo:"negociacao", stage:"prospeccao", origem:"Instagram", valor:0, grupoNegociacaoId:grupoId||null, grupoNegociacaoLabel:grupoLabel||null });
      setLeads(prev=>[data,...prev]);
      setNovaLinhaGrupo(null);
    }catch(e){ alert(e.response?.data?.erro||"Erro"); }
  };

  const filtered = (arr) => arr.filter(l=>{
    const q=search.toLowerCase();
    return !q||l.nome?.toLowerCase().includes(q)||l.empresa?.toLowerCase().includes(q);
  });

  const leadsSemGrupo   = leads.filter(l=>!l.grupoNegociacaoId);
  const leadsPorGrupo   = (id) => leads.filter(l=>String(l.grupoNegociacaoId)===String(id));
  const todosGrupos     = [{ _id:"__sem_grupo__", label:"Sem grupo", color:"#8E8E93", _virtual:true }, ...grupos];

  const totalPipeline = leads.filter(l=>!["fechado","perdido"].includes(l.stage)).reduce((a,l)=>a+Number(l.valor||0),0);
  const totalFechado  = leads.filter(l=>l.stage==="fechado").reduce((a,l)=>a+Number(l.valor||0),0);

  const TH=({children,w,center})=>(
    <th style={{ padding:"10px 14px", fontSize:11, color:theme.textMuted, fontWeight:600, letterSpacing:".05em", textTransform:"uppercase", textAlign:center?"center":"left", borderRight:`1px solid ${theme.border}`, width:w, minWidth:w, background:theme.bgInput, whiteSpace:"nowrap" }}>{children}</th>
  );
  const TD=({children,w,center})=>(
    <td style={{ padding:"0 10px", height:44, borderRight:`1px solid ${theme.border}`, borderBottom:`1px solid ${theme.border}`, width:w, minWidth:w, textAlign:center?"center":"left", verticalAlign:"middle" }}>{children}</td>
  );

  return (
    <div style={{ fontFamily:"'Inter',-apple-system,sans-serif", background:theme.bg, minHeight:"100vh" }}
      onClick={()=>setMenuMover(null)}>

      {/* Header */}
      <div style={{ padding:"20px 28px 0", background:theme.bgSecond, borderBottom:`1px solid ${theme.border}` }}>

        {/* Banner mover selecionados */}
        {selected.length > 0 && (
          <div style={{ background:ORANGE+"18", border:`1px solid ${ORANGE}44`, borderRadius:10, padding:"10px 16px", marginBottom:12, display:"flex", alignItems:"center", gap:12, flexWrap:"wrap" }}>
            <span style={{ fontSize:13, fontWeight:600, color:ORANGE }}>{selected.length} selecionado{selected.length>1?"s":""}</span>
            <span style={{ fontSize:13, color:theme.textMuted }}>→ Mover para:</span>
            <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
              <button onClick={()=>moverSelecionadosParaGrupo(null,null)} style={{ background:"#8E8E9322", border:"1px solid #8E8E9344", borderRadius:8, padding:"4px 12px", color:"#8E8E93", fontSize:12, fontWeight:600, cursor:"pointer" }}>Sem grupo</button>
              {grupos.map(g=>(
                <button key={g._id} onClick={()=>moverSelecionadosParaGrupo(g._id,g.label)} style={{ background:g.color+"22", border:`1px solid ${g.color}44`, borderRadius:8, padding:"4px 12px", color:g.color, fontSize:12, fontWeight:600, cursor:"pointer" }}>{g.label}</button>
              ))}
            </div>
            <button onClick={()=>setSelected([])} style={{ marginLeft:"auto", background:"none", border:"none", color:theme.textMuted, fontSize:12, cursor:"pointer", textDecoration:"underline" }}>Cancelar</button>
          </div>
        )}

        <div style={{ display:"flex", alignItems:"center", gap:20, marginBottom:16, flexWrap:"wrap" }}>
          <div style={{ display:"flex", gap:24 }}>
            {[["Total",leads.length,theme.text],["Pipeline",fmt(totalPipeline),ORANGE],["Fechado",fmt(totalFechado),"#10b981"]].map(([label,val,color])=>(
              <div key={label}>
                <div style={{ fontSize:11, color:theme.textMuted, fontWeight:500 }}>{label}</div>
                <div style={{ fontSize:20, fontWeight:800, color }}>{val}</div>
              </div>
            ))}
          </div>
          <div style={{ marginLeft:"auto", display:"flex", gap:10, alignItems:"center" }}>
            <input placeholder="🔍 Pesquisar..." value={search} onChange={e=>setSearch(e.target.value)}
              style={{ background:theme.bgCard, border:`1.5px solid ${theme.border}`, borderRadius:10, padding:"8px 14px", color:theme.text, fontSize:13, outline:"none", colorScheme:theme.name, width:200, fontFamily:"'Inter',sans-serif" }}
              onFocus={e=>e.target.style.borderColor=ORANGE} onBlur={e=>e.target.style.borderColor=theme.border}/>
            <button onClick={()=>setModalGrupo({})} style={{ background:theme.bgInput, border:`1px solid ${theme.border}`, borderRadius:10, padding:"8px 16px", color:theme.textSub, fontWeight:600, fontSize:13, cursor:"pointer" }}>+ Novo grupo</button>
            <button onClick={()=>setModal({})} style={{ background:`linear-gradient(135deg,${ORANGE},#FF9A5C)`, border:"none", borderRadius:10, padding:"9px 18px", color:"#fff", fontWeight:700, fontSize:13, cursor:"pointer", boxShadow:`0 4px 12px ${ORANGE}44` }}>+ Criar oportunidade</button>
          </div>
        </div>
      </div>

      {/* Tabela */}
      <div style={{ overflowX:"auto", padding:"16px 0 40px" }}>
        <table style={{ width:"100%", borderCollapse:"collapse", minWidth:960 }}>
          <thead>
            <tr>
              <TH w={36}><input type="checkbox" onChange={e=>setSelected(e.target.checked?leads.map(l=>l._id):[])}/></TH>
              <TH w={260}>Oportunidade</TH>
              <TH w={170} center>Etapa</TH>
              <TH w={120}>Responsável</TH>
              <TH w={120}>Valor</TH>
              <TH w={130}>Contato</TH>
              <TH w={120}>Fechamento</TH>
              <TH w={80} center>Prob.</TH>
              <TH w={52} center>⋮</TH>
            </tr>
          </thead>

          {loading ? (
            <tbody><tr><td colSpan={9} style={{ padding:60, textAlign:"center", color:theme.textMuted }}>Carregando...</td></tr></tbody>
          ) : (
            todosGrupos.map(grupo=>{
              const grupoLeads = filtered(grupo._id==="__sem_grupo__"?leadsSemGrupo:leadsPorGrupo(grupo._id));
              const totalV     = grupoLeads.reduce((a,l)=>a+Number(l.valor||0),0);
              const colapsado  = colapsados[grupo._id];
              const isDragOver = dragOverGrupo===grupo._id;

              return (
                <tbody key={grupo._id}
                  onDragOver={e=>{ e.preventDefault(); setDragOverGrupo(grupo._id); }}
                  onDragLeave={()=>setDragOverGrupo(null)}
                  onDrop={e=>{
                    e.preventDefault();
                    const id = e.dataTransfer.getData("leadId");
                    if(id) moverParaGrupo(id, grupo._id==="__sem_grupo__"?null:grupo._id, grupo._id==="__sem_grupo__"?null:grupo.label);
                    setDragOverGrupo(null); setDragLeadId(null);
                  }}>

                  {/* Header grupo */}
                  <tr>
                    <td colSpan={9} style={{ padding:0 }}>
                      <div style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 14px", borderBottom:`3px solid ${isDragOver?grupo.color:grupo.color}`, background:isDragOver?grupo.color+"20":grupo.color+"08", userSelect:"none", transition:"background .15s" }}>
                        <span onClick={()=>setColapsados(c=>({...c,[grupo._id]:!c[grupo._id]}))} style={{ color:grupo.color, fontSize:14, cursor:"pointer", display:"inline-block", transform:colapsado?"rotate(-90deg)":"rotate(0deg)", transition:"transform .2s" }}>▾</span>
                        <span style={{ fontWeight:700, color:grupo.color, fontSize:14 }}>{grupo.label}</span>
                        <span style={{ background:grupo.color+"25", color:grupo.color, borderRadius:99, fontSize:11, fontWeight:700, padding:"2px 10px" }}>{grupoLeads.length}</span>

                        {/* Indicador de drop */}
                        {isDragOver && (
                          <span style={{ fontSize:12, color:grupo.color, fontWeight:600, background:grupo.color+"22", borderRadius:6, padding:"2px 10px" }}>
                            ↓ Solte aqui para mover
                          </span>
                        )}

                        {!grupo._virtual && (
                          <button onClick={()=>setModalGrupo(grupo)} style={{ background:"none", border:"none", color:theme.textMuted, cursor:"pointer", fontSize:12, padding:"2px 8px", borderRadius:6 }}
                            onMouseEnter={e=>{ e.currentTarget.style.background=grupo.color+"18"; e.currentTarget.style.color=grupo.color; }}
                            onMouseLeave={e=>{ e.currentTarget.style.background="none"; e.currentTarget.style.color=theme.textMuted; }}>
                            ✏️ Editar
                          </button>
                        )}
                        <span style={{ marginLeft:"auto", fontSize:13, color:theme.textMuted, fontWeight:600 }}>{fmt(totalV)}</span>
                      </div>
                    </td>
                  </tr>

                  {/* Linhas */}
                  {!colapsado && grupoLeads.map(lead=>{
                    const isSel  = selected.includes(lead._id);
                    const isDrag = dragLeadId===lead._id;
                    return (
                      <tr key={lead._id}
                        draggable
                        onDragStart={e=>{ e.dataTransfer.setData("leadId",lead._id); setDragLeadId(lead._id); }}
                        onDragEnd={()=>setDragLeadId(null)}
                        style={{ background:isSel?ORANGE+"08":isDrag?"rgba(255,107,43,.05)":theme.bgCard, transition:"background .1s", opacity:isDrag?.6:1, cursor:"grab" }}
                        onMouseEnter={e=>{ if(!isSel&&!isDrag) e.currentTarget.style.background=theme.bgHover; }}
                        onMouseLeave={e=>{ e.currentTarget.style.background=isSel?ORANGE+"08":isDrag?"rgba(255,107,43,.05)":theme.bgCard; }}>

                        <TD w={36} center>
                          <input type="checkbox" checked={isSel} onChange={()=>setSelected(prev=>prev.includes(lead._id)?prev.filter(x=>x!==lead._id):[...prev,lead._id])} onClick={e=>e.stopPropagation()}/>
                        </TD>
                        <TD w={260}>
                          <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                            {/* Handle de drag */}
                            <span style={{ color:theme.border, fontSize:14, cursor:"grab", flexShrink:0, userSelect:"none" }} title="Arrastar para outro grupo">⠿</span>
                            <div style={{ width:3, height:32, borderRadius:99, background:ETAPAS_NEG.find(e=>e.id===lead.stage)?.color||theme.border, flexShrink:0 }}/>
                            <div style={{ flex:1, overflow:"hidden" }}>
                              <InlineEdit value={lead.nome} placeholder="Nome" onChange={v=>atualizarCampo(lead._id,"nome",v)} style={{ fontWeight:600 }}/>
                              {lead.empresa && <div style={{ fontSize:11, color:theme.textMuted, paddingLeft:4 }}>{lead.empresa}</div>}
                            </div>
                          </div>
                        </TD>
                        <TD w={170} center>
                          <EtapaBadge stage={lead.stage} etapaNegociacao={lead.etapaNegociacao} onChange={(s,label)=>atualizarEtapa(lead._id,s,label)}/>
                        </TD>
                        <TD w={120}>
                          <span style={{ fontSize:12, color:theme.textSub }}>{lead.nomeResponsavel||"—"}</span>
                        </TD>
                        <TD w={120}>
                          <InlineEdit value={lead.valor?fmt(lead.valor):""} placeholder="R$ 0" onChange={v=>atualizarCampo(lead._id,"valor",Number(v.replace(/\D/g,"")))} style={{ color:ORANGE, fontWeight:700 }}/>
                        </TD>
                        <TD w={130}>
                          <InlineEdit value={lead.telefone} placeholder="Contato" onChange={v=>atualizarCampo(lead._id,"telefone",v)}/>
                        </TD>
                        <TD w={120}>
                          <div style={{ fontSize:12, color:lead.dataFechamento&&new Date(lead.dataFechamento)<new Date()&&lead.stage!=="fechado"?"#ef4444":theme.textMuted }}>
                            {lead.dataFechamento?fmtData(lead.dataFechamento):<span style={{ color:theme.textMuted, fontSize:11 }}>—</span>}
                          </div>
                        </TD>
                        <TD w={80} center>
                          {lead.probabilidade?(
                            <div style={{ display:"flex", alignItems:"center", justifyContent:"center" }}>
                              <div style={{ width:30, height:30, borderRadius:"50%", background:`conic-gradient(${ORANGE} ${lead.probabilidade*3.6}deg,${theme.bgInput} 0deg)`, display:"flex", alignItems:"center", justifyContent:"center" }}>
                                <div style={{ width:22, height:22, borderRadius:"50%", background:theme.bgCard, display:"flex", alignItems:"center", justifyContent:"center", fontSize:8, fontWeight:700, color:ORANGE }}>{lead.probabilidade}%</div>
                              </div>
                            </div>
                          ):<span style={{ color:theme.textMuted, fontSize:12 }}>—</span>}
                        </TD>
                        <TD w={52} center>
                          <button onClick={e=>{ e.stopPropagation(); setMenuMover({ lead, x:e.clientX, y:e.clientY }); }}
                            style={{ background:"none", border:"none", color:theme.textMuted, cursor:"pointer", fontSize:20, borderRadius:6, padding:"2px 8px", width:32, height:32, display:"flex", alignItems:"center", justifyContent:"center" }}
                            onMouseEnter={e=>{ e.currentTarget.style.background=theme.bgInput; e.currentTarget.style.color=theme.text; }}
                            onMouseLeave={e=>{ e.currentTarget.style.background="none"; e.currentTarget.style.color=theme.textMuted; }}>⋮</button>
                        </TD>
                      </tr>
                    );
                  })}

                  {/* Nova linha */}
                  {!colapsado && novaLinhaGrupo===grupo._id && (
                    <LinhaNovaRow grupoId={grupo._id==="__sem_grupo__"?null:grupo._id} grupoLabel={grupo._id==="__sem_grupo__"?null:grupo.label} onAdd={adicionarLead} onCancel={()=>setNovaLinhaGrupo(null)}/>
                  )}

                  {/* Botão adicionar */}
                  {!colapsado && (
                    <tr>
                      <td colSpan={9} style={{ padding:"6px 14px", borderBottom:`1px solid ${theme.border}`, background:theme.bg }}>
                        <button onClick={()=>setNovaLinhaGrupo(grupo._id)} style={{ background:"none", border:"none", color:theme.textMuted, cursor:"pointer", fontSize:13, display:"flex", alignItems:"center", gap:6, padding:"5px 8px", borderRadius:8, fontFamily:"'Inter',sans-serif" }}
                          onMouseEnter={e=>{ e.currentTarget.style.background=grupo.color+"10"; e.currentTarget.style.color=grupo.color; }}
                          onMouseLeave={e=>{ e.currentTarget.style.background="none"; e.currentTarget.style.color=theme.textMuted; }}>
                          + Adicionar oportunidade
                        </button>
                      </td>
                    </tr>
                  )}

                  {/* Total do grupo */}
                  {!colapsado && grupoLeads.length>0 && (
                    <tr style={{ background:grupo.color+"06" }}>
                      <td colSpan={4} style={{ padding:"8px 14px", fontSize:12, color:theme.textMuted, borderBottom:`1px solid ${theme.border}`, fontWeight:500 }}>{grupoLeads.length} oportunidade{grupoLeads.length!==1?"s":""}</td>
                      <td style={{ padding:"8px 14px", fontSize:14, fontWeight:800, color:grupo.color, borderBottom:`1px solid ${theme.border}` }}>{fmt(totalV)}</td>
                      <td colSpan={4} style={{ borderBottom:`1px solid ${theme.border}` }}/>
                    </tr>
                  )}

                  <tr><td colSpan={9} style={{ height:18, background:theme.bg }}/></tr>
                </tbody>
              );
            })
          )}
        </table>

        {/* Botão novo grupo no rodapé */}
        <div style={{ padding:"8px 28px" }}>
          <button onClick={()=>setModalGrupo({})} style={{ background:"none", border:`1.5px dashed ${theme.border}`, borderRadius:10, padding:"10px 20px", color:theme.textMuted, cursor:"pointer", fontSize:13, display:"flex", alignItems:"center", gap:8, fontFamily:"'Inter',sans-serif", width:"100%" }}
            onMouseEnter={e=>{ e.currentTarget.style.borderColor=ORANGE; e.currentTarget.style.color=ORANGE; }}
            onMouseLeave={e=>{ e.currentTarget.style.borderColor=theme.border; e.currentTarget.style.color=theme.textMuted; }}>
            + Adicionar novo grupo
          </button>
        </div>
      </div>

      {/* Menu mover (⋮) */}
      {menuMover && (
        <div style={{ position:"fixed", top:menuMover.y, left:menuMover.x, zIndex:3000 }} onClick={e=>e.stopPropagation()}>
          <div style={{ background:"#2C2C2F", border:"1px solid #3D3D42", borderRadius:14, padding:8, minWidth:220, boxShadow:"0 16px 48px rgba(0,0,0,.6)" }}>
            <div style={{ fontSize:11, color:"#8E8E93", fontWeight:600, letterSpacing:".05em", textTransform:"uppercase", padding:"6px 10px 4px" }}>Mover para grupo</div>
            <div onClick={()=>{ moverParaGrupo(menuMover.lead._id,null,null); setMenuMover(null); }}
              style={{ display:"flex", alignItems:"center", gap:10, padding:"8px 10px", borderRadius:8, cursor:"pointer" }}
              onMouseEnter={e=>e.currentTarget.style.background="#8E8E9318"}
              onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <div style={{ width:10, height:10, borderRadius:3, background:"#8E8E93" }}/>
              <span style={{ fontSize:13, color:"#F2F2F7" }}>Sem grupo</span>
            </div>
            {grupos.map(g=>(
              <div key={g._id} onClick={()=>{ moverParaGrupo(menuMover.lead._id,g._id,g.label); setMenuMover(null); }}
                style={{ display:"flex", alignItems:"center", gap:10, padding:"8px 10px", borderRadius:8, cursor:"pointer" }}
                onMouseEnter={e=>e.currentTarget.style.background=g.color+"18"}
                onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                <div style={{ width:10, height:10, borderRadius:3, background:g.color }}/>
                <span style={{ fontSize:13, color:"#F2F2F7" }}>{g.label}</span>
                {String(menuMover.lead.grupoNegociacaoId)===String(g._id) && <span style={{ marginLeft:"auto", fontSize:11, color:g.color }}>atual</span>}
              </div>
            ))}
            <div style={{ borderTop:"1px solid #3D3D42", margin:"6px 0" }}/>
            <div onClick={()=>{ setModal(menuMover.lead); setMenuMover(null); }}
              style={{ display:"flex", alignItems:"center", gap:10, padding:"8px 10px", borderRadius:8, cursor:"pointer" }}
              onMouseEnter={e=>e.currentTarget.style.background="#ffffff10"}
              onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <span style={{ fontSize:13, color:"#F2F2F7" }}>✏️ Editar oportunidade</span>
            </div>
          </div>
        </div>
      )}

      {/* Modais */}
      {modal!==null && <ModalOportunidade lead={Object.keys(modal).length?modal:null} grupos={grupos} onClose={()=>setModal(null)} onSave={salvarLead} onDelete={excluirLead}/>}
      {modalGrupo!==null && <ModalGrupo grupo={Object.keys(modalGrupo).length?modalGrupo:null} onClose={()=>setModalGrupo(null)} onSave={salvarGrupo} onDelete={excluirGrupo}/>}
    </div>
  );
}
